/**
 * Authorization header for staff calls to the server, from the admin console's session. Used by the calls to
 * /api/testing, which require a signed-in staff member since 23 Sep 2026 (src/server/services/testingAccess.js).
 */
import { supabaseAdmin } from '@/integrations/supabase/client';

export async function staffAuthHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabaseAdmin.auth.getSession();
  return session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {};
}
